import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { useDareCard } from 'root/src/client/web/list/listItemComponents/dare/hooks/useDareCard'
import classNames from 'classnames'
import {
	colorsNew,
} from 'root/src/client/web/commonStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { faGamepadAlt } from '@fortawesome/pro-light-svg-icons/faGamepadAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo } from 'react'
import { CompletionType } from 'root/src/shared/rewards/constants'
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip'
import { MdAutoMode } from 'react-icons/md'
import ErrorIcon from '@mui/icons-material/Error'

export const DareCardSeparator = withProjectCardStyle(({ classes }) => {
	const {
		dare: { level, battlePass, clipsOnly, completion },
		extraData: {
			brand,
		},
	} = useDareCard()

	if (battlePass) {
		return (
			<div className={classNames(
				'layout-row layout-align-center',
				classes.projectAssigne,
				classes.overlay,
			)}
			>
				<BattlePassTierBadge tier={battlePass.tier} />
				<div className={classes.namesContainer}>
					<CompletionTypeBadge completionType={completion?.type} />
					<BattlePass battlePass={battlePass} />
					<Difficulty level={level} />
				</div>
			</div>
		)
	}

	return (
		<div className={classNames(
			'layout-row layout-align-center',
			classes.projectAssigne,
			classes.overlay,
		)}
		>
			<DareCardSeparatorIcon
				icon={faGamepadAlt}
				alt={brand.brandName}
			/>
			<div className={classes.namesContainer}>
				<CompletionTypeBadge completionType={completion?.type} />
				<OnlyClipsWarning isDisplay={clipsOnly} />
				<Difficulty level={level} />
			</div>
		</div>
	)
})

export const DareCardSeparatorIcon = withProjectCardStyle(({ classes, icon, ...props }) => (
	<div className={classNames(classes.circleBorder, classes.bgBlack)}>
		<FontAwesomeIcon size="lg" icon={icon} {...props} />
	</div>
))

const Difficulty = withProjectCardStyle(({ classes, level }) => (
	<div style={{
		display: 'flex',
		flexDirection: 'column',
		fontSize: 12,
		alignItems: 'center',
		justifyContent: 'center',
	}}
	>
		<Typography
			color={colorsNew.light4}
			variant={typographyVariants.microBold}
		>
			DIFFICULTY
		</Typography>
		<Typography className={classes.uppercase} variant={typographyVariants.mini}>
			{level}
		</Typography>
	</div>
))

const BattlePass = ({ battlePass }) => (
	<div className="ml-4 flex flex-initial flex-col gap-0.5 justify-center">
		<span className="uppercase text-left text-2xs text-light-4">Battle pass</span>
		<span
			title={battlePass.name}
			className="uppercase text-left text-xs truncate max-w-40"
		>
			{battlePass.name}
		</span>
	</div>
)

const BattlePassTierBadge = ({ tier }) => (
	<div className="flex flex-initial flex-col justify-center items-center tracking-wide h-[50px] w-[50px] rounded-full drop-shadow-teal-glow bg-black border-2 border-white">
		<span className="text-2xs text-teal text-center">Tier</span>
		<span className="text-center font-bold">{tier}</span>
	</div>
)

export const CompletionTypeBadge = memo(({ completionType }) => {
	if (completionType === CompletionType.GAME_INTEGRATED) {
		return <GameIntegratedCompletionTypeBadge />
	}

	return null
})

export const GameIntegratedCompletionTypeBadge = memo(() => (
	<BaseTooltip
		tooltip={(
			<BaseTooltipContent className="flex w-full">
				This Dare is integrated with the game<br /> you can complete it by playing the game<br /> and receive the reward inside the game.
			</BaseTooltipContent>
		)}
	>
		<div className="rounded-full p-2 flex items-center justify-center">
			<MdAutoMode size="24" />
		</div>
	</BaseTooltip>
))

const OnlyClipsWarning = ({ isDisplay }) => {
	if (!isDisplay) {
		return null
	}

	return (
		<div className="flex items-center ml-6">
			<BaseTooltip
				tooltip={(
					<BaseTooltipContent className="text-black bg-white py-1 rounded-xl">
						If delivering from Twitch<br />
						You can only deliver a clip
					</BaseTooltipContent>
				)}
			>
				<ErrorIcon fontSize="medium" />
			</BaseTooltip>
		</div>
	)
}
